var $ = require('jquery')

$(function () {
  var $nav = $('#header')
  var navDivided = $nav.height() / 2

  /**
   * Search functionality
   */
  $('.component-search').on('click', function () {
    $('.component-search-bar').toggleClass('search-active')

    if ($('.component-search-active').hasClass('search-active')) {
      $('#s').focus()
    }
  })
  $('.close-search-bar').on('click', function () {
    $('.component-search-bar').removeClass('search-active')
  })

  /**
   * Change background on Primary menu when scrolling
   */
  $(document).on('scroll', function () {
    $('header').toggleClass('scrolled', $(this).scrollTop() > navDivided)
  })

  /**
   * Toggle mobile menu
   */
  $('.hamburger').on('click', function () {
    $(this).toggleClass('is-active')
    $('.header-main__right').toggleClass('menu-is-active')
  })

  /**
   * Primary menu dropdown functionality
   */
  $('.nav__items-item-depth_0').on('click', function () {
    $('.arrow-down', this).toggleClass('selected')
    $('.header-menu__wrapper', this).toggleClass('mobile-submenu-is-active')
  })

  /**
   * Primary menu languages functionality
   */
  $('.languages .languages-curr').on('click', function () {
    $('.arrow-down-top', this).toggleClass('selected')
  })

  /**
   * Primary menu languages functionality
   */
  $('nav .languages').on('click', function () {
    $('.languages-list', this)
      .toggleClass('selected')
      .focus()
  })

  /**
   * Dropdown menu functionality
   * TODO:
   *  - Refactor
   */
  $('.dropdown-toggle.depth_0').on('click', function (e) {
    e.preventDefault()

    // Is this already open?
    if (
      $(this)
        .parent()
        .hasClass('submenu-active')
    ) {
      $('.submenu-active').removeClass('submenu-active')
    } else {
      $('.mobile-submenu-is-active').removeClass('mobile-submenu-is-active')
      $('.submenu-active').removeClass('submenu-active')
      $('.selected').removeClass('selected')
      $(this)
        .parent()
        .addClass('submenu-active')
    }

  })

  /**
   * Landingpage anchor
   */
  $('#landing-anchor-link').on('click', function (e) {

    const href = $(this).attr('href');
    const headerHeight = $('.header-main').height();
    const grandheaderHeight = $('#grand-header').height();
    const scrollTo = $('#content').offset().top - (headerHeight + grandheaderHeight)

    if(href == '#content'){

      e.preventDefault();

      $('html, body').animate({
        scrollTop: scrollTo
      }, 500);

    }
    
  })
  
})
